import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const PersonaList = ({ personas }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const fromWebDemo = location.state?.fromWebDemo || false;
  const fromTransactionalDemo = location.state?.fromTransactionalDemo || false;
  // Remove Smartly widget when component mounts
  React.useEffect(() => {
    const smartlyScript = document.getElementById('smartly-script');
    if (smartlyScript) smartlyScript.remove();
    const smartlyWidget = document.getElementById('smartly-webchat');
    if (smartlyWidget) smartlyWidget.remove();
  }, []);

  return (
    <div className="persona-list-container" style={{ padding: '32px 0', maxWidth: 1000, margin: '0 auto' }}>
      {fromWebDemo && (
        <div className="demo-context-header">
          <h1 className="persona-list-title">Customer Support Agent (Web) Demo</h1>
          <p className="demo-context-description">Select a persona to interact with the Ooredoo customer support agent</p>
        </div>
      )}
      {fromTransactionalDemo && (
        <div className="demo-context-header">
          <h2 className="persona-list-title">Transactional Agent Demo (Not finished yet!)</h2>
          <p className="demo-context-description">Select a persona to experience the personalized AI agent with API integrations</p>
        </div>
      )}
      <div className="persona-list">
        {personas.map((persona) => (
          <div key={persona._id}>
            {fromWebDemo || fromTransactionalDemo ? (
              <div
                onClick={() => {
                  if (fromWebDemo) {
                    navigate('/demo/web-support', { state: { persona } });
                  } else if (fromTransactionalDemo) {
                    navigate(`/persona/${persona._id}`, { state: { fromTransactionalDemo: true } });
                  }
                }}
                style={{
                  width: 140,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  background: '#fff',
                  border: '1px solid #eee',
                  borderRadius: 12,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  padding: 18,
                  marginBottom: 16,
                  cursor: 'pointer',
                  transition: 'transform 0.18s, box-shadow 0.18s',
                  willChange: 'transform',
                  textDecoration: 'none',
                  color: 'inherit',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-6px) scale(1.04)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                }}
              >
                <img
                  src={persona.imageUrl || '/assets/img/default_avatar.svg'}
                  alt={persona.name}
                  style={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover', border: '1px solid #ccc', background: '#fafafa', marginBottom: 10 }}
                  onError={e => { e.target.onerror = null; e.target.src = '/assets/img/default_avatar.svg'; }}
                />
                <div style={{ fontWeight: 600, fontSize: 17, marginBottom: 2, textAlign: 'center' }}>{persona.name}</div>
                <div style={{ fontSize: 15, color: '#666', marginBottom: 2, textAlign: 'center' }}>{persona.type}</div>
                <div style={{ fontSize: 15, color: '#666', textAlign: 'center' }}>{persona.phone_number}</div>
              </div>
            ) : (
              <Link
                to={`/persona/${persona._id}`}
                style={{
                  width: 140,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  background: '#fff',
                  border: '1px solid #eee',
                  borderRadius: 12,
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  padding: 18,
                  marginBottom: 16,
                  cursor: 'pointer',
                  transition: 'transform 0.18s, box-shadow 0.18s',
                  willChange: 'transform',
                  textDecoration: 'none',
                  color: 'inherit',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-6px) scale(1.04)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'none';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
                }}
              >
                <img
                  src={persona.imageUrl || '/assets/img/default_avatar.svg'}
                  alt={persona.name}
                  style={{ width: 72, height: 72, borderRadius: '50%', objectFit: 'cover', border: '1px solid #ccc', background: '#fafafa', marginBottom: 10 }}
                  onError={e => { e.target.onerror = null; e.target.src = '/assets/img/default_avatar.svg'; }}
                />
                <div style={{ fontWeight: 600, fontSize: 17, marginBottom: 2, textAlign: 'center' }}>{persona.name}</div>
                <div style={{ fontSize: 15, color: '#666', marginBottom: 2, textAlign: 'center' }}>{persona.type}</div>
                <div style={{ fontSize: 15, color: '#666', textAlign: 'center' }}>{persona.phone_number}</div>
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PersonaList;
